<template>
  <div v-if="hidePage" v-loading="loading">
    <div class="searcBtn" style="display: flex;justify-content: space-between;align-items: center;">
      <h3>气体灭火</h3>
      <el-button type="primary" @click="showDia = true">查询历史</el-button>
    </div>
    <div class="list">
      <div v-for="(item, index) in list" :key="index" class="content">
        <img class="qitiFire" src="@/assets/img/qitiFire.png"/>
        <p :class="item.electric == null || item.electric == 0 ? 'off' : 'on'">{{ item.electric == null || item.electric == 0 ? "监控" : "启动" }}</p>
        <p class="company_index">设备编号：{{ item.deviceNo }}</p>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="showDia" title="历史记录查询" width="70%">
      <div class="content">
        <el-form ref="form" :model="query" label-width="80px">
          <el-form-item label="设备编号">
            <el-select v-model="query.deviceNo" placeholder="选择设备编号" @change="query.pageNum = 0">
              <el-option v-for="(item, index) in list" :key="index" :value="item.deviceNo"></el-option>
            </el-select>
          </el-form-item>
          <div class="midden" style="display: flex;">
            <el-form-item class="flex1" label="开始时间:" style="width:100%">
              <el-date-picker
                  v-model="query.startTime"
                  :default-time="'00:00:00'"
                  placeholder="选择开始日期时间"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="query.pageNum = 1"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item class="flex1" label="结束时间:" style="width:100%">
              <el-date-picker
                  v-model="query.endTime"
                  :default-time="'23:59:59'"
                  placeholder="选择结束日期时间"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="query.pageNum = 1"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="viewNow">查询</el-button>
              <el-button type="primary" @click="Reset">重置</el-button>
            </el-form-item>
          </div>

          <div class="botoom">
            <el-table :data="searchList" border height="500" style="width: 100%">
              <el-table-column align="center" fixed header-align="center" label="编号" type="index" width="80"></el-table-column>
              <el-table-column align="center" header-align="center" label="报警时间" prop="nowtime">
                <template slot-scope="scope">
                  <p>{{ scope.row.nowtime == null ? "暂无数据" : scope.row.nowtime }}</p>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" label="报警类型" prop="evenClass">
                <template slot-scope="scope">
                  <p>{{ scope.row.evenClass == null ? "暂无数据" : scope.row.evenClass }}</p>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" label="联系电话" prop="phone" width="160">
                <template slot-scope="scope">
                  <p>{{ scope.row.phone == null ? "暂无数据" : scope.row.phone }}</p>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" label="设备类型" prop="deviceType">
                <template slot-scope="scope">
                  <p>{{ scope.row.deviceType == null ? "暂无数据" : scope.row.deviceType }}</p>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" label="报警节点" prop="detailAddr">
                <template slot-scope="scope">
                  <p>{{ scope.row.detailAddr == null ? "暂无数据" : scope.row.detailAddr }}</p>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" label="报警地点" prop="msgDescribe">
                <template slot-scope="scope">
                  <p>{{ scope.row.msgDescribe == null ? "暂无数据" : scope.row.msgDescribe }}</p>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
                :current-page.sync="query.pageNum"
                :page-size.sync="query.pageSize"
                :page-sizes="[5, 10, 20, 30]"
                :total="total"
                background
                layout="prev, pager, next,sizes,total"
                @size-change="getSearchList"
                @current-change="getSearchList"
            >
            </el-pagination>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import config from "../../utils/config.js";
import {gasFireList, gasFireSearch} from "../../api/facility.js";
import {mapState} from "vuex";

export default {
  props: ["cpNum", "nowDevice"],
  data() {
    return {
      list: [], // 数据列表
      listarea: {
        type: "",
        wsType: 1,
      },
      hidePage: false, // 隐藏页面
      websock: null, // 实时推送
      show: false,
      loading: true,
      searchList: [],
      query: {
        pageSize: 10,
        pageNum: 1,
        deviceNo: null,
        startTime: "",
        endTime: "",
      },
      total: 0,
      showDia: false,
      form: {
        deviceType: "", // 设备类型
        evenClass: "", // 报警类型
        phone: "", //联系电话
        nowtime: "", // 报警时间
        detailAddr: "", //报警节点
        msgDescribe: "", // 报警地点
      },
    };
  },
  computed: {
    ...mapState(["otherBjList"]),
  },
  watch: {
    // 单位名称 请求接口
    cpNum() {
      this.getList();
    },
  },

  mounted() {
    if (this.cpNum) {
      this.getList();
    }
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    this.websock.close(); //离开路由之后断开websocket连接
  },

  methods: {
    getList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
      gasFireList({companyNum: cNum, ...this.query}).then((res) => {
        log(res, "get list");
        if (res.data.length) {
          this.list = res.data;
          this.query.deviceNo = res.data[0].deviceNo;
          this.form.deviceNo = res.data[0].deviceNo;

          this.hidePage = true;
          this.loading = false;
          this.getSearchList();
        }
        if (!res.data.length) {
          this.hidePage = false;
          this.$message.warning("该业务尚未开通，请联系管理员");
        }
      });
    },
    getSearchList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
      gasFireSearch({companyNum: cNum, ...Object.assign(this.query)}).then((res) => {
        // log(res, 'GET search list');
        this.searchList = res.data.data;
        this.total = res.data.total;
        this.query.deviceNo = res.data.data[0]?.address;
        this.form.deviceNo = res.data.data[0]?.address;
      });
    },

    edit(index) {
      this.show = !this.show;
    },
    initWebSocket() {
      //初始化weosocket
      // const wsuri = "ws://47.105.170.47:8888/ws/mqt";
      let wsUrl = "";
      if (process.env.NODE_ENV == "development") {
        //本地
        wsUrl = config.wsUrltest;
      } else if (process.env.NODE_ENV == "production") {
        //线上
        wsUrl = config.wsUrl;
      }
      this.websock = new WebSocket(wsUrl);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      log("链接");
      //连接建立之后执行send方法发送数据
      let message = "fasong";
      this.websocketsend(JSON.stringify(message));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);
      for (const iterator of redata) {
        if (iterator.type == "273" && iterator.wsType == 1) {
          for (const item of this.list) {
            if (item.deviceNo == iterator.deviceNo) {
              // item = Object.assign(item, iterator);
              item.electric = iterator.electric;
            }
          }
          this.list = [...this.list];
        }
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    viewNow() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
      gasFireSearch({companyNum: cNum, ...Object.assign(this.query)}).then((res) => {
        console.log(res, "view");
        this.searchList = res.data.data;
        this.total = res.data.total;
        this.query.deviceNo = res.data.data[0].address;
        this.query.pageNum = 1;
        this.getSearchList();
      });
    },
    Reset() {
      this.query.startTime = "";
      this.query.endTime = "";
      this.query.pageNum = 1;
      this.total = 0;
      this.searchList = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.fire {
  background: none !important;
}

.list {
  margin-top: 10px;
  display: flex;

  .content {
    width: 300px;
    height: 400px;
    border: 1px solid #000;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-around;
    margin: 0 40px;
    position: relative;
    margin-left: 0;

    .qitiFire {
      width: 300px;
      height: 400px;
    }

    .on {
      cursor: pointer;
      position: absolute;
      background-color: #4a9dff;
      color: #fff;
      font-size: 16px;
      top: 81px;
      left: 135px;
      z-index: 88;
      width: 51px;
      height: 39px;
      text-align: center;
      line-height: 39px;
    }

    .off {
      cursor: pointer;
      position: absolute;
      background-color: #000408;
      color: #fff;
      font-size: 16px;
      top: 81px;
      left: 135px;
      z-index: 88;
      width: 51px;
      height: 39px;
      text-align: center;
      line-height: 39px;
    }

    .company_index {
      font-weight: bolder;
      position: absolute;
      bottom: 15px;
      left: 65px;
    }
  }
}

.midden {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
